import { Component, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import {
	AuthenticationResult,
	EventType as MsalEventType,
	InteractionStatus,
} from '@azure/msal-browser';
import { TranslateService } from '@ngx-translate/core';
import { jwtDecode } from 'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { filter } from 'rxjs';
import {environment} from './core/environments/environment';

@Component({
	standalone: false,
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})

export class AppComponent  implements OnInit {
	translate: TranslateService;

	constructor(
		public translateService: TranslateService,
		public cookie: CookieService,
		public msalService: MsalService,
		private msalBroadcastService: MsalBroadcastService
	) {

		this.translate = translateService;

		this.translate.setDefaultLang('pt');

		if (this.cookie.get('language')) {
			this.translate.use(this.cookie.get('language'));
		} else {
			this.translate.use('en');
			this.cookie.set('language', 'en');
		}

		this.ensureActiveAccount();
	}

	ngOnInit(): void {
		this.msalBroadcastService.msalSubject$
			.pipe(filter((event) => event.eventType === MsalEventType.LOGIN_SUCCESS))
			.subscribe(() => {
				if (this.ensureActiveAccount()) {
					this.getClaims();
				}
			});

		this.msalBroadcastService.inProgress$
			.pipe(filter((status) => status === InteractionStatus.None))
			.subscribe(() => {
				this.ensureActiveAccount();
			});
	}

	private ensureActiveAccount(): boolean {
		const currentActiveAccount = this.msalService.instance.getActiveAccount();
		if (currentActiveAccount) {
			return true;
		}

		const account = this.msalService.instance.getAllAccounts()[0];
		if (!account) {
			return false;
		}

		this.msalService.instance.setActiveAccount(account);
		return true;
	}

	getClaims() {
		if (!this.ensureActiveAccount()) {
			console.error('No active account found');
			return Promise.resolve(null);
		}

		const account = this.msalService.instance.getActiveAccount();
		if (account) {
			const scopes = environment.vectorBffConfig.scopes;
			const request = {
				account,
				scopes
			};
			this.msalService.instance.acquireTokenSilent(request)
				.then((result: AuthenticationResult) => {
					const claims = jwtDecode(result.accessToken);
					this.cookie.set("country", claims['country']);
					this.cookie.set('username', claims['cdsid'])
				})
				.catch(() => {
					console.error('Token acquisition for BFF failed.');
					return null;
				});
		} else {
			console.error('No active account found');
			return Promise.resolve(null);
		}
	}
}
